export const revenueByYearSelector = (period: string) => (state: any) => state.revenueByYear.data; 